//
//

import { mapActions, mapGetters } from "vuex";
import { date } from "quasar";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import FabricSearch from "@/components/q-fabric-search.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import deleteS from "@/assets/images/Buttons/deleteS.svg";
import deleteHover from "@/assets/images/Buttons/deleteHover.svg";

import { APP_DATE_DOT_FORMAT } from "@/assets/js/appConfig";
import ShareFilterModal from "./ShareFilterModal.vue";

export default {
    name: "SavedFiltersModal",
    components: {
        AQModal,
        AQButton,
        AQDialog,
        AQCheckbox,
        AQMenu,
        AQTooltip,
        ShareFilterModal,
        FabricSearch,
        AQCard
    },
    props: {
        selectedProcess: { type: Object, default: () => ({}) },
        pageType: { type: String, default: "" }
    },
    data() {
        return {
            opened: true,
            filtersName: this.$t("dashboard.yourFilters"),
            dialogTitle: this.$tc("dashboard.filterDeleteTitle", 1),
            dialogText: this.$tc("dashboard.filterDeleteText", 1),
            filtersSelectedList: [],
            currentHovered: false,
            bulkState: false,
            showDialog: false,
            deleteIcon: deleteS,
            deleteIconHover: deleteHover,
            hovered: null,
            search: "",
            emptyState: false,
            share: false,
            optionsList: [],
            toBeDeleted: [],
            deleteIndex: null,
            copyItemsToReturn: [],
            countTotal: 0,
            checkedFilters: [],
            deleteOption: [{
                label: this.$t("dashboard.bulkDelete")
            }],
            popoverModel: [],
            shareFilterId: "",
            shareFilterName: "",
            showLoadTooltip: true
        };
    },
    computed: {
        ...mapGetters("main", ["getCurrentApplicationId"]),
        ...mapGetters("perspectiveBuilder", ["getPerspectiveId"]),
        localOptionsList() {
            const filtersArray = this.optionsList;
            this.emptyState = !filtersArray.length;
            const itemsToReturn = [];
            if (this.search && this.search.length) {
                const lowerCaseSearchValue = this.search.toLowerCase();
                for (let i = 0; i < filtersArray.length; i++) {
                    if (filtersArray[i].filterName.toLowerCase().includes(lowerCaseSearchValue)) {
                        itemsToReturn.push(filtersArray[i]);
                    }
                }
                this.emptyState = !itemsToReturn.length;
                this.copyItemsToReturn = itemsToReturn;
                this.countTotal = itemsToReturn.length;
                return itemsToReturn;
            }
            this.copyItemsToReturn = [];
            this.countTotal = filtersArray.length;
            return filtersArray;
        }
    },
    created() {
        const payload = {
            interfaceName: "reports",
            processDefinitionId: this.selectedProcess.id,
            perspectiveCase: this.pageType === "searchPerspectives",
            perspectiveId: this.getPerspectiveId,
            appId: this.getCurrentApplicationId
        };
        this.getAllSavedFilters(payload).then(data => {
            if (data && data.length) {
                this.optionsList = data
                    .map(element => ({ id: element.id, filterName: element.name, filterDate: date.formatDate(element.modifiedOn, APP_DATE_DOT_FORMAT) }));

                data.forEach(element => {
                    if (element.favorite) {
                        this.checkedFilters.push(element.id);
                    }
                });
            }
        });
    },
    methods: {
        ...mapActions("reports", ["getAllSavedFilters", "deleteReportsFilters", "favoriteReportsFilters", "generateFilterLink", "getFilter"]),
        actionsDlg() {
            this.$emit("closeFiltersModal");
            this.opened = false;
        },
        hideLoadTooltip() {
            this.showLoadTooltip = false;
        },
        displayLoadTooltip() {
            this.showLoadTooltip = true;
        },
        showDeleteIcon(index) {
            this.currentHovered = index;
        },
        hideDeleteIcon() {
            this.currentHovered = null;
        },
        deleteFilter(id, index) {
            this.showDialog = true;
            this.deleteIndex = index;
            this.toBeDeleted = [];
            this.toBeDeleted.push(id);
        },
        bulkDeleteOption() {
            this.bulkState = true;
            this.popoverModel = [];
        },
        cancelBulkAction() {
            this.bulkState = false;
            this.filtersSelectedList = [];
        },
        deleteBulkAction() {
            const dataType = this.filtersSelectedList.length > 1 ? 2 : 1;
            this.dialogTitle = this.$tc("dashboard.filterDeleteTitle", dataType);
            this.dialogText = this.$tc("dashboard.filterDeleteText", dataType);
            this.showDialog = !!this.filtersSelectedList.length;
        },
        dialogConfirmAction(actionMessage) {
            if (actionMessage === "ok") {
                const payload = {
                    perspectiveCase: this.pageType === "searchPerspectives",
                    perspectiveId: this.getPerspectiveId,
                    appId: this.getCurrentApplicationId,
                    filtersList: []
                };
                if (this.filtersSelectedList.length) {
                    payload.filtersList = [...this.filtersSelectedList];
                    this.deleteReportsFilters(payload).then(
                        () => {
                            this.optionsList = this.optionsList.filter(element => !this.filtersSelectedList.includes(element.id));
                            this.filtersSelectedList = [];
                            this.bulkState = false;
                            this.$emit("updateFilterList", this.optionsList);
                        }
                    );
                } else {
                    payload.filtersList = [...this.toBeDeleted];
                    this.deleteReportsFilters(payload).then(
                        () => {
                            this.optionsList.splice(this.deleteIndex, 1);
                            this.$emit("updateFilterList", this.optionsList);
                        }
                    );
                }
            }
        },
        saveFiterAsFavorite(filterId, filterExist) {
            const msg = filterExist ? this.$t("dashboard.filterFavoriteMessage") : this.$t("dashboard.filterUnfavoriteMessage");
            const payload = {
                id: filterId,
                perspectiveCase: this.pageType === "searchPerspectives",
                perspectiveId: this.getPerspectiveId,
                appId: this.getCurrentApplicationId
            };
            this.favoriteReportsFilters(payload).then(
                () => {
                    this.$toast.showNotify({
                        type: "success",
                        message: msg
                    });
                }
            );
        },
        selectFilter(filterId) {
            if (!this.bulkState) {
                let filterExist = false;
                if (this.checkedFilters.includes(filterId)) {
                    this.checkedFilters = this.checkedFilters.filter(el => el !== filterId);
                } else {
                    this.checkedFilters.push(filterId);
                    filterExist = true;
                }
                this.saveFiterAsFavorite(filterId, filterExist);
            }
        },
        selectAllItems() {
            if (this.copyItemsToReturn.length) {
                this.filtersSelectedList = this.copyItemsToReturn.map(element => element.id);
            } else {
                this.filtersSelectedList = this.optionsList.map(element => element.id);
            }
        },
        shareThisFilter(id, name) {
            const payload = {
                id,
                processDefinitionId: this.selectedProcess.id,
                pageType: this.pageType,
                perspectiveCase: this.pageType === "searchPerspectives",
                perspectiveId: this.getPerspectiveId,
                appId: this.getCurrentApplicationId
            };
            this.generateFilterLink(payload).then(link => {
                this.filterLink = link;
                this.shareFilterId = id;
                this.shareFilterName = name;
                this.share = true;
            });
        },
        closeShareModal() {
            this.share = false;
        },
        openFilter(id) {
            if (!this.bulkState) {
                const payload = {
                    id,
                    processDefinitionId: this.selectedProcess.id,
                    perspectiveCase: this.pageType === "searchPerspectives",
                    perspectiveId: this.getPerspectiveId,
                    appId: this.getCurrentApplicationId
                };
                this.getFilter(payload).then(
                    data => {
                        this.$emit("getFilterDetails", data);
                        this.$emit("closeFiltersModal");
                        this.opened = false;
                    }
                ).catch(() => {
                    this.$toast.showNotify({
                        type: "error",
                        code: "filter-loadFail",
                        message: this.$t("searchPerspectives.loadFilterError")
                    });
                });
            }
        }
    }
};
